import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { GrocyBarcodeDialogComponent } from './components/barcode-dialog/barcode-dialog.component';
import { GrocyProductActionDialogComponent } from './components/product-action-dialog/product-action-dialog.component';
import { GrocyProductActionsMenuComponent } from './components/product-actions-menu/product-actions-menu.component';

@NgModule({
  declarations: [GrocyBarcodeDialogComponent, GrocyProductActionDialogComponent, GrocyProductActionsMenuComponent],
  imports: [AppFormsModule, CommonModule, FormsModule, MaterialModule, ReactiveFormsModule, RouterModule, SharedModule],
  exports: [GrocyBarcodeDialogComponent, GrocyProductActionsMenuComponent],
})
export class GrocyProductActionsModule {}
